export default __webpack_public_path__ + "static/media/SDG8.b62397ad.png";